export default __webpack_public_path__ + "static/media/Certificate_map.77293afe.png";